{
  "app.title": "Craft-Imperium",
  "app.tagline": "Rule clearly. Act precisely.",
  "common.loading": "Loading …",
  "common.retry": "Retry",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.send": "Send",
  "common.search": "Search",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.none": "None",
  "common.unknown": "Unknown",
  "common.available": "Available",
  "common.unavailable": "Unavailable",
  "common.coordinates": "Coordinates",
  "common.points": "Points",
  "common.revision": "Revision",
  "common.details": "Details",
  "common.simple": "Simple",
  "common.expert": "Expert",
  "common.open": "Open",
  "common.close": "Close",
  "common.refresh": "Refresh",
  "common.filter": "Filter",
  "common.all": "All",
  "common.enabled": "On",
  "common.disabled": "Off",
  "common.quantity": "Quantity",
  "common.status": "Status",
  "common.world": "World",
  "common.village": "Village",
  "common.error": "Error",
  "common.empty": "There is nothing to show here yet.",
  "auth.login": "Sign in",
  "auth.loginName": "Login or email",
  "auth.password": "Password",
  "auth.totp": "2FA code (optional)",
  "auth.signOut": "Sign out",
  "auth.sessionExpired": "The session has expired. Please sign in again.",
  "auth.rememberMe": "Stay signed in",
  "auth.rememberLogin": "Remember username",
  "auth.passwordManagerHint": "Your browser password manager can save your password; Craft-Imperium does not store it itself.",
  "auth.register": "Register",
  "auth.registerTitle": "Create account",
  "auth.username": "Username",
  "auth.email": "Email address",
  "auth.passwordConfirmation": "Confirm password",
  "auth.createAccount": "Create account",
  "auth.minimumAge": "I confirm that I meet the required minimum age.",
  "auth.acceptTerms": "I accept the currently valid terms of service.",
  "auth.acceptPrivacy": "I accept the currently valid privacy policy.",
  "auth.registrationCreated": "Account created. Please verify your email address using the link we sent you.",
  "auth.registerConflict": "The username or email address is already in use.",
  "auth.passwordRequirements": "At least 12 characters; known compromised default passwords are rejected.",
  "auth.legalOutdated": "The legal terms have changed. Please reopen registration.",
  "auth.legalRequired": "Please confirm minimum age, terms of service and privacy policy.",
  "auth.tokenInvalid": "The link is invalid or has expired.",
  "auth.validationFailed": "Please check your input.",
  "auth.rateLimited": "Too many attempts. Please try again later.",
  "auth.verificationComplete": "Email address verified successfully. You can now sign in.",
  "auth.emailVerificationRequired": "Please verify your email address before joining a world.",
  "auth.resendVerification": "Send verification link again",
  "auth.verificationResent": "A new verification link has been requested.",
  "worlds.title": "Worlds",
  "worlds.joined": "Joined",
  "worlds.open": "Registration open",
  "worlds.pending": "Spawn is being prepared",
  "worlds.noVillage": "No owned village is available yet.",
  "nav.dashboard": "Dashboard",
  "nav.map": "Map",
  "nav.buildings": "Buildings",
  "nav.army": "Army",
  "nav.research": "Research",
  "nav.smithy": "Smithy",
  "nav.market": "Market",
  "nav.reports": "Reports",
  "nav.messages": "Messages",
  "nav.alliance": "Alliance",
  "nav.quests": "Quests",
  "nav.notifications": "Notifications",
  "nav.settings": "Settings",
  "nav.admin": "Profile editor",
  "nav.more": "More",
  "nav.worlds": "Worlds",
  "connection.online": "Online",
  "connection.reconnecting": "Reconnecting …",
  "connection.offline": "Offline – commands are blocked",
  "village.switch": "Switch village",
  "village.search": "Search villages",
  "village.group": "Group",
  "village.noMatch": "No matching village.",
  "resources.title": "Resources",
  "resources.capacity": "Capacity",
  "resources.rate": "Production/s",
  "resources.lost": "Lost production",
  "dashboard.title": "Village dashboard",
  "dashboard.population": "Population",
  "dashboard.profile": "Rule profile",
  "dashboard.quick": "Quick access",
  "dashboard.slowHint": "Data loads independently; commands remain unchanged until the server confirms them.",
  "buildings.title": "Buildings",
  "buildings.built": "Built",
  "buildings.notBuilt": "Not built",
  "buildings.level": "Level",
  "buildings.queue": "Build queue",
  "army.title": "Army",
  "army.total": "Total",
  "army.reserved": "Reserved",
  "army.attack": "Plan attack",
  "research.title": "Research",
  "smithy.title": "Smithy",
  "market.title": "Market",
  "alliance.title": "Alliance",
  "quests.title": "Quests & events",
  "feature.serverDriven": "This view uses authorized server data only. Unavailable mechanics are not recreated locally.",
  "feature.unavailableTitle": "Feature unavailable in this world",
  "feature.unavailableText": "The active rule profile does not expose this feature. No hidden data was loaded.",
  "map.title": "World map",
  "map.panUp": "Pan up",
  "map.panDown": "Pan down",
  "map.panLeft": "Pan left",
  "map.panRight": "Pan right",
  "map.selected": "Selection",
  "map.tapHint": "Tapping only selects. A map tap never executes a game command.",
  "map.empty": "No visible objects are present in this map chunk.",
  "attack.title": "Plan attack",
  "attack.targetX": "Target X",
  "attack.targetY": "Target Y",
  "attack.preview": "Review draft",
  "attack.confirm": "Send attack",
  "attack.draftOnly": "A draft is not an attack. Only final confirmation sends a command.",
  "attack.offline": "An attack cannot be sent while offline.",
  "attack.sent": "The server accepted the attack.",
  "reports.title": "Report center",
  "reports.search": "Search reports",
  "reports.favorite": "Favorite",
  "reports.archived": "Archived",
  "reports.calculator": "Open in combat calculator",
  "reports.privacy": "Shares contain only field groups authorized by the server.",
  "messages.title": "Messages",
  "messages.compose": "Compose message",
  "messages.recipient": "Recipient account ID",
  "messages.subject": "Subject",
  "messages.body": "Message",
  "messages.shortcutHint": "Keyboard shortcuts are disabled while typing and during IME composition.",
  "notifications.title": "Notifications",
  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.theme": "Appearance",
  "settings.themeSystem": "System",
  "settings.themeLight": "Light",
  "settings.themeDark": "Dark",
  "settings.navMode": "Desktop navigation",
  "settings.navIconsText": "Icons + text",
  "settings.navIconsOnly": "Icons only",
  "settings.navTextOnly": "Text only",
  "settings.navCollapsed": "Collapsed",
  "settings.detailed": "Detailed views",
  "settings.reducedMotion": "Reduce motion",
  "settings.shortcuts": "Keyboard shortcuts",
  "settings.tips": "Hints",
  "settings.volume": "Volume",
  "settings.shortcutsList": "M Map · R Reports · D Dashboard · A Army",
  "settings.pwa": "App installation",
  "settings.install": "Install app",
  "settings.installed": "Installed as an app",
  "settings.notInstallable": "The browser is not currently offering installation.",
  "settings.offlinePolicy": "Offline mode provides the app shell and static assets only. API responses and game commands are never simulated from a service-worker cache.",
  "admin.title": "Rule profile editor",
  "admin.draftId": "Draft ID",
  "admin.load": "Load draft",
  "admin.metadata": "Metadata",
  "admin.expertJson": "Canonical profile content (JSON)",
  "admin.sameDraft": "Simple and Expert edit the same canonical draft; there is no second rule engine in the client.",
  "admin.validate": "Validate",
  "admin.valid": "Draft is valid.",
  "admin.saved": "Draft saved.",
  "errors.offlineCommand": "The command was not sent because the connection is offline.",
  "errors.load": "Data could not be loaded.",
  "errors.notFound": "Page not found",
  "errors.forbidden": "You do not have permission to open this view.",
  "a11y.skip": "Skip to content",
  "army.unit": "Unit",
  "attack.targetVillageId": "Target village ID",
  "attack.target": "Target",
  "reports.calculatorDraft": "Calculator draft",
  "reports.unknownStaysUnknown": "Unknown values remain unknown.",
  "map.chunk": "Chunk",
  "map.panControls": "Map pan controls",
  "map.visibleObjects": "Visible map objects",
  "a11y.primaryNavigation": "Primary navigation",
  "resources.wood": "Wood",
  "resources.clay": "Clay",
  "resources.iron": "Iron",
  "dashboard.populationFree": "free",
  "army.trainingQueue": "Training queue",
  "buildings.build": "Build",
  "buildings.upgrade": "Upgrade",
  "buildings.maxLevel": "Maximum level",
  "buildings.noMore": "This rule profile contains no further buildable buildings.",
  "buildings.queueEmpty": "No active build orders.",
  "building.headquarters": "Headquarters",
  "building.woodcutter": "Woodcutter",
  "building.quarry": "Clay pit",
  "building.clayPit": "Clay pit",
  "building.ironMine": "Iron mine",
  "building.warehouse": "Warehouse",
  "map.home": "Center on my village",
  "errors.command": "The command was not accepted. Refresh and try again.",
  "reports.select": "Select a report on the left to view its details."
}
